import { useState } from "react";

type TabNavigationProps = {
  onNext?: () => Promise<void>;
  onPrev?: () => void;
  currentIndex: number;
};

export const useTabNavigation = (onValidate: (tabIndex?: number) => Promise<void>) => {
  const [tabNavigation, setTabNavigation] = useState<TabNavigationProps>();

  return {
    tabNavigation,
    setTabNavigation: (p: TabNavigationProps) => {
      setTabNavigation({
        ...p,
        onNext: p.onNext
          ? () => {
              return onValidate(p.currentIndex).then(p.onNext);
            }
          : undefined,
      });
    },
  };
};
